document.addEventListener('DOMContentLoaded', () => {
  const parser = new DOMParser()
  const NEXT = '[li-if="paginate.next"] a'

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) loadNextPage(entry.target) })
  }, { rootMargin: '800px 0px' })

  const loadNextPage = async (nav) => {
    observer.unobserve(nav)
    const section = nav.closest('.shopify-section')
    const grids = section.querySelectorAll('.filter_product-list')
    const grid = grids[grids.length - 1]
    const url = new URL(nav.querySelector(NEXT).getAttribute('href'), location.href)
    url.searchParams.set('section_id', section.id.replace('shopify-section-', ''))

    try {
      const response = await fetch(url)
      if (!response.ok) throw new Error(`[infinite-scroll] ${response.status} ${url}`)
      const newDocument = parser.parseFromString(await response.text(), 'text/html')
      if (!grid.isConnected) return // a filter render replaced the grid while this page loaded
      // Grids wrap cards differently (.display-contents spans two subgrid rows, a bare card spans one),
      // so each new card goes into a copy of the target grid's own item wrapper, never the source grid's
      const template = grid.lastElementChild.cloneNode(true)
      template.querySelector('.product-item_component').parentElement.replaceChildren()
      grid.append(...[...newDocument.querySelectorAll('.product-item_component')].map((card) => {
        const item = template.cloneNode(true)
        let slot = item
        while (slot.firstElementChild) slot = slot.firstElementChild
        slot.append(card)
        return item
      }))
      const newNav = newDocument.querySelector('.pagination_component')
      nav.replaceWith(newNav)
      observe(newNav)
    } catch (error) {
      nav.style.visibility = ''
      console.error(error)
    }
  }

  const observe = (nav) => {
    if (!nav.querySelector(NEXT)) return nav.remove()
    nav.style.visibility = 'hidden'
    observer.observe(nav)
  }

  const init = () => {
    observer.disconnect()
    document.querySelectorAll('.pagination_component').forEach((nav) => {
      if (nav.closest('.shopify-section').querySelector('.filter_product-list')) observe(nav)
    })
  }

  document.addEventListener('liquify:filter-rendered', init)
  init()
})
